<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">填写新的账户</div>
<div class="content" mat-dialog-content>
  <div class="txt1">请输入一个未加入任何家庭组的 Gmail 邮箱</div>
  <form [formGroup]="formGroup">
    <div class="item">
      <div class="label"><span style="color: #d50000">*</span> 账号：</div>
      <input type="text" formControlName="user_name" />
    </div>
    <div class="item">
      <div class="label"><span style="color: #d50000">*</span> 密码：</div>
      <input type="text" formControlName="password" />
    </div>
    <div class="item">
      <div class="label">备用安全码1：</div>
      <input type="text" formControlName="one_code" />
    </div>
    <div class="item">
      <div class="label">备用安全码2：</div>
      <input type="text" formControlName="two_code" />
    </div>
  </form>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="onOk()"
  >
    提交
  </button>
</div>
